// service-config-lint-disable: runtime-enriched-config-export-flow-covered -- this service is intentionally enriched at runtime, and the export flow already handles it as well.
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import { ReducedMotionSymbol, SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { IDeviceInfoDefinition, IDeviceInfoServiceConfig } from '@wix/site-service-device-info/definition'
import { DeviceInfoDefinition as definition } from '@wix/site-service-device-info/definition'
import { DeviceInfoService as impl } from '@wix/site-service-device-info/implementations'
import { name } from './symbols'
import type { DeviceInfoServiceSiteConfig } from './types'

export const siteDeviceInfoService: FactoryWithDependencies<ServiceProvider<IDeviceInfoDefinition, typeof impl>> =
	withDependencies(
		[named(SiteFeatureConfigSymbol, name), ReducedMotionSymbol],
		(
			siteFeatureConfig: DeviceInfoServiceSiteConfig,
			reducedMotion: boolean
		): ServiceProvider<IDeviceInfoDefinition, typeof impl> => {
			const config: IDeviceInfoServiceConfig = {
				...siteFeatureConfig,
				reducedMotion,
			}

			return {
				definition,
				impl,
				config,
				platformConfig: config,
			}
		}
	)
